module.exports = [{"type":"hash","text":"Numbers"},{"type":"normal","text":"","children":[{"type":"html","text":"Decimal numbers are returned as \"Strings\" in order to preserve full precision. It is recommended that the numbers are converted to \"Strings\" to avoid truncation and precision loss."},{"type":"html","text":"Integer numbers (such as trade ID and sequences) are unquoted."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/api/basic/03_digital_rule.json
// module id = C2jk
// module chunks = 3